import { render, staticRenderFns } from "./ConfigureRepeatableField.vue?vue&type=template&id=2847b06c&scoped=true"
import script from "./ConfigureRepeatableField.vue?vue&type=script&lang=js"
export * from "./ConfigureRepeatableField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRepeatableField.vue?vue&type=style&index=0&id=2847b06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847b06c",
  null
  
)

export default component.exports